import { useEffect } from "react"
import { useFormikContext } from "formik"

import { ErrorDisplay } from "../../../../../core/api/errorTypes"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { useMerchant } from "../../../../merchants/merchantHooks"
import {
    type GetProductGroupDetailsResponse,
    getProductGroupDetails,
    ProductGroupQuery,
} from "../../productGroup/productGroupApi"

import type { CreateUpdateProductFormValues } from "../productsTypes"

const selectProductGroupAvailability = (data: GetProductGroupDetailsResponse) => data.productGroup.availabilityDetails

// the group list and product details carry no availability, only the group details do
export function useProductGroupAvailabilitySync() {
    const { merchantId } = useMerchant()
    const { values, setFieldValue } = useFormikContext<CreateUpdateProductFormValues>()
    const productGroup = values.productGroup

    const { data: availabilityDetails, isSuccess } = useApiQuery(getProductGroupDetails, {
        queryName: ProductGroupQuery.DETAILS,
        dependencies: {
            merchantId,
            productGroupId: productGroup?.id ?? 0,
        },
        enabled: Boolean(productGroup),
        select: selectProductGroupAvailability,
        // the form still works without the group's limits, so a failure stays silent
        errorDisplay: ErrorDisplay.NONE,
    })

    useEffect(() => {
        if (!productGroup || !isSuccess || productGroup.availabilityDetails === availabilityDetails) return
        setFieldValue("productGroup", { ...productGroup, availabilityDetails })
    }, [productGroup, isSuccess, availabilityDetails, setFieldValue])
}
